import {TPeriodPickerValue} from '@edna/components';
import {TCurrency} from '@edna/utils';

import {TItemId} from 'src/constants';
import {ETransactionType} from 'src/containers/AccountStatement/definitions';

export type TLeadContact = {
  id?: number | string;
  companyName: string;
  contactName: string;
  phone: string;
  email?: string;
  comment?: string;
};

export type TReportFilters = {
  agentId?: TItemId;
  filter?: string;
  period?: TPeriodPickerValue | null;
};

export type TAgentReportPayments = Record<
  TCurrency,
  {
    paymentsTotal: number;
    commissionTotal: number;
  }
>;

export type TAgentReport = {
  id: number;
  transactionId: number;
  companyName: string;
  taxNumber: string;
  subject: string;
  reasonCode: ETransactionType.WHATSAPP_CONNECTION_FEE | ETransactionType.WHATSAPP_LICENSE_PAYMENT;
  paymentDate: string;
  paymentAmount: number;
  commissionAmount: number;
  currency: TCurrency;
};

export type TAgentAccountingDocument = {
  id: number;
  accountingPeriod: string;
  fileName: string;
  fileUrl: string;
  createdAt: string;
};

export enum EAgentPaymentsTab {
  REPORT = 'report',
  DOCUMENTS = 'documents',
}
